/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * This layer groups functionality of
 * <a href="../classes/L.TomTomTrafficLayer.html" class="alert-link"> traffic layer </a>
 * and <a href="../classes/L.TomTomTrafficIncidentsLayer.html" class="alert-link"> traffic incidents </a>
 * In most situations you will want to use these layers together and refresh them at the same time, so
 * we are providing this layer to make your work easier.
 *
 * If you use this layer there will be only one timer and it will issue only one request to check if
 * traffic data is up to date. If you create layers on your own, each layer will have it's own timer and
 * will check for data freshness on its own. You can specify how ofter the data should be refreshed.
 *
 *
 * @class TomTomTrafficWithIncidentsLayer
 * @extends L.LayerGroup
 * @namespace L
 * @module Map
 * @constructor
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#layergroup">Leaflet's LayerGroup</a>
 *     class allows. The additional options, which are TomTom specific, are described below.
 * @param {Object|Boolean} [options.traffic] Options which will be used for traffic and traffic incidents layers.
 * Please refer to the
 * <a href="../classes/L.TomTomTrafficLayer.html" class="alert-link"> docs </a>
 * to check what options you can use.
 * @param {Number} [options.refresh=30000] The traffic and traffic incidents information changes and needs to be updated
 *     periodically. By default, it is refreshed every 30 seconds. This parameter's value represents the time
 *     in milliseconds between each update interval. The value must be 30000 or greater.
 */

define([
    'leaflet',
    './trafficRefresher',
    './trafficLayer',
    './trafficIncidentsLayer'
],
function(
    L,
    trafficRefresher,
    trafficLayer,
    trafficIncidentsLayer
) {

    L.TomTomTrafficWithIncidentsLayer = L.LayerGroup.extend({
        initialize: function(options) {
            L.setOptions(this, options);
        },
        _trafficModelIdCallback: function(trafficModelId) {
            this.trafficLayer.setTrafficModelId(trafficModelId);
            this.incidentsLayer.setTrafficModelId(trafficModelId);
        },
        /**
        * Name of traffic with incidents layer. It can be used to differentiate layers.
        * @property name
        * @default "trafficWithIncidents"
        * @type String
        */
        name: 'trafficWithIncidents',
        options: {
            pane: 'tilePane'
        },
        onAdd: function(map) {
            var trafficOptions = L.setOptions({options: {_noRefresher: true}}, this.options);
            this.trafficLayer = trafficLayer(trafficOptions);
            this.incidentsLayer = trafficIncidentsLayer(trafficOptions);
            this.trafficLayerWithIncidents = L.layerGroup([this.trafficLayer, this.incidentsLayer]);
            this.trafficRefresherIntervalId =
                trafficRefresher.addRefresherWithModelId(undefined, this._trafficModelIdCallback, this);
            map.addLayer(this.trafficLayerWithIncidents);
        },
        onRemove: function() {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.trafficLayerWithIncidents.remove();
        },
        updateOptions: function(options) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.trafficRefresherIntervalId =
                trafficRefresher.addRefresherWithModelId(options, this._trafficModelIdCallback, this);
            L.setOptions(this, options);
        }
    });

    L.tomTomTrafficWithIncidentsLayer = function(options) {
        return new L.TomTomTrafficWithIncidentsLayer(options);
    };

    return L.tomTomTrafficWithIncidentsLayer;
});



// WEBPACK FOOTER //
// ./display/layers/trafficWithIncidents.js